<template>
  <div class="login float">
    <div class="form">
      <div class="header">
        <b>{{$t('login.registration')}}.</b>
      </div>
      <div class="body blue">
        <div class="form-item" :class="{'has-error': ('name' in errors)}">
          <label for="email">{{ $t('login.name') }}</label>
          <br>
          <input type="text" class="text-input" v-model='form.name'>
          <div v-if="('name' in errors)">
            <small v-for="(msg, index) in errors.name" :key="index" class="error-msg">{{ msg }}</small>
          </div>
        </div>
        <div class="form-item" :class="{'has-error': ('email' in errors)}">
          <label for="email">{{ $t('login.email') }}</label>
          <br>
          <input type="email" class="text-input" v-model='form.email'>
          <div v-if="('email' in errors)">
            <small v-for="(msg, index) in errors.email" :key="index" class="error-msg">{{ msg }}</small>
          </div>
        </div>
        <div class="form-item" :class="{'has-error': ('password' in errors)}">
          <label for="">{{ $t('login.password') }}</label>
          <br>
          <input type="password" class="text-input" v-model='form.password'>
          <div v-if="('password' in errors)">
            <small v-for="(msg, index) in errors.password" :key="index" class="error-msg">{{ msg }}</small>
          </div>
        </div>
        <div class="form-item">
          <label for="">{{ $t('login.password_repeat') }}</label>
          <br>
          <input type="password" class="text-input" v-model='form.password_confirmation'>
        </div>
        <div class="form-item">
          <label for="">{{ $t('login.invitation_code') }}</label>
          <br>
          <input type="text" class="text-input" v-model='form.invitation_code' placeholder="ABC123">
        </div>
        <div class="form-item">
          <label class="check">
            <input type="checkbox" v-model="form.terms">
            <i18n path="login.understood" tag="span">
              <router-link :to="{ name: 'Terms'}" tag="a" target="_blank">
                {{ $t('login.terms')}}
              </router-link>
            </i18n>
          </label>
        </div>
        <div class="form-item">
          <button class="btn btn-block" @click='register'>{{ $t('login.register_now') }}</button>
        </div>
      </div>
    </div>
    <br>

    <small>
      <router-link :to="{ name: 'Login'}" tag="a">
        <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>{{ $t('login.back')}}
      </router-link>
    </small>

  </div>
</template>


<script>
import api from '../api'

export default {
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        invitation_code: null,
        terms: false
      },
      errors: {}
    }
  },
  mounted () {
    this.$Progress.finish()
  },
  methods: {
    register () {
      var self = this
      if (self.form.terms) {
        self.$Progress.set(25)

        api.postRegister(self.form)
          .then(
            () => {
              self.$Progress.set(50)
              var username = self.form.email
              var password = self.form.password
              api.postLogin(
                username,
                password
              )
              .then((d) => {
                self.$store.commit('setToken', d.data.access_token)
                self.$Progress.set(75)

                api.getUser()
                  .then((r) => {
                    self.$store.commit('setUser', r.data)
                    self.$router.push('/cockpit')
                    self.$Progress.finish()
                  })
                  .catch(() => self.$Progress.fail())
              })
              .catch(() => self.$Progress.fail())
            })
          .catch((e) => {
            self.errors = e.response.data
            self.$Progress.fail()
          })
      }
    }
  }
}
</script>
<style scoped lang="stylus" src="../styles/_Login.styl"/>



// WEBPACK FOOTER //
// src/components/Register.vue